// 商品设置价格的区间
export const COMMODITY_PRICE = {
  min: 0,
  max: 100000,
};



// WEBPACK FOOTER //
// ./src/utils/const.js